import { c as _c } from "react/compiler-runtime";
import { Button, TextField } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { useState } from "react";
/**
 * @returns Username and password fields plus a save button.
 * The entered values are persisted via the item's onSave callback.
 */
export function CredentialsControl(t0) {
  const $ = _c(16);
  const {
    item
  } = t0;
  const [username, setUsername] = useState(item.username);
  const [password, setPassword] = useState(item.password);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: "100%",
      minWidth: "14rem",
      gap: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== username) {
    t2 = <TextField placeholder="Username" text={username} onTextChanged={setUsername} fullWidth={true} />;
    $[1] = username;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== password) {
    t3 = <TextField placeholder="Password" type="password" text={password} onTextChanged={setPassword} fullWidth={true} />;
    $[3] = password;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== item || $[6] !== password || $[7] !== username) {
    t4 = () => item.onSave(username, password);
    $[5] = item;
    $[6] = password;
    $[7] = username;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      justifySelf: "end"
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <Button variant="secondary" size="s" onClick={t4} sx={t5}>Save</Button>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t6) {
    t7 = <Stack direction="column" onKeyDown={_temp} sx={t1}>{t2}{t3}{t6}</Stack>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function _temp(event) {
  return event.stopPropagation();
}